import { ref } from '@vue/composition-api'

export default function useOptionsMask() {
  const optionsMask = ref({
    cpf: {
      blocks: [3, 3, 3, 2],
      uppercase: true,
      delimiters: ['.', '.', '-'],
    },
    cnpj: {
      blocks: [2, 3, 3, 4, 2],
      uppercase: true,
      delimiters: ['.', '.', '/', '-'],
    },
    inscricaoEstadual: {
      blocks: [2, 3, 3, 3],
      uppercase: true,
      delimiters: ['.', '.', '.'],
    },
    cep: {
      blocks: [5, 3],
      delimiter: '-',
      uppercase: true,
    },
    creditCard: {
      creditCard: true,
    },
    date: {
      date: true,
      delimiter: '-',
      datePattern: ['Y', 'm', 'd'],
    },
    phone: {
      phone: true,
      phoneRegionCode: 'US',
    },
    time: {
      time: true,
      timePattern: ['h', 'm', 's'],
    },
    number: {
      numeral: true,
      numeralThousandsGroupStyle: 'thousand',
    },
    block: {
      blocks: [4, 3, 3],
      uppercase: true,
    },
    delimiter: {
      delimiter: '·',
      blocks: [3, 3, 3],
      uppercase: true,
    },
    customDelimiter: {
      delimiters: ['.', '.', '-'],
      blocks: [3, 3, 3, 2],
      uppercase: true,
    },
    prefix: {
      prefix: '+55',
      blocks: [3, 3, 3, 4],
      uppercase: true,
    },
    valueBr: {
      prefix: 'R$ ',
      decimal: ',',
      thousands: '.',
      precision: 2,
    },
  })

  return {
    optionsMask,
  }
}
